import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Alert } from '../../../../assets/icons/alert.svg';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;

  h1 {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 8px;
    color: ${(props) => props.theme.colors.primaryDark2};
  }

  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 28px;
    text-align: center;
    color: #070c2f;
    margin-top: 34px;
    margin-bottom: 16px;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    color: #222;
    text-align: center;
    line-height: 31px;
  }

  @media screen and (max-width: 960px) {
    h1 {
      font-size: 24px;
    }

    p {
      font-size: 16px;
      text-align: center;
      line-height: 21px;
    }
  }
`;

const ErrorMessage: React.FC = () => {
  return (
    <Main>
      <div>
        <Alert />
      </div>
      <h2>Ops! Não encontramos o seu endereço</h2>
      <p>
        Não encontramos nenhum endereço válido de acordo com o cadastro
        fornecido pelo credor. Entre em contato diretamente com o credor para
        realizar a atualização dos seus dados cadastrais.
      </p>
    </Main>
  );
};

export default ErrorMessage;
